export const Thankyou = () => (

  <section
    className="min-h-screen bg-[#0A0A0B] px-4 sm:px-6 lg:px-8 py-12 flex items-center justify-center"
    style={{
      fontFamily:
        '"Inter" sans-serif',
    }}
  >
    <div className="w-full max-w-5xl mx-auto text-center">
      <div className="space-y-5 sm:space-y-6 md:space-y-8">

```
    <div>
      <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light leading-none text-[#C9A96E]">
        All Set..!
      </h1>
    </div>

    <div>
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl leading-tight text-[#C9A96E] px-2">
        Thank You For Sharing Your Information
      </h2>
    </div>

    <div className="max-w-2xl mx-auto px-4">
      <p className="text-sm sm:text-base md:text-lg leading-relaxed text-[#C9A96E]">
        Our team will contact you shortly to share all the details.
      </p>
    </div>

    <div className="pt-2">
      <a href="/">
        <button
          className="
          inline-flex
          items-center
          justify-center
          gap-3
          mt-4
          px-10
          py-4
          text-base
          font-normal
          tracking-[0.02em]
          rounded-[2px]
          border-0
          cursor-pointer
          bg-[#C9A96E]
          text-[#141416]
          transition-all
          duration-300
          hover:bg-[#B8965D]
          hover:-translate-y-[2px]
        "
        >
          Back to Home Screen
        </button>
      </a>
    </div>

  </div>
</div>
```

  </section>
);
